import { SvgIcon, SvgIconProps } from '@mui/material';

export const ClientPlusIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M2 21.0004C1.99992 19.4608 2.44413 17.9538 3.27935 16.6603C4.11456 15.3669 5.30527 14.3419 6.7086 13.7085C8.11193 13.075 9.66824 12.8599 11.1908 13.0891C12.7133 13.3183 14.1373 13.9819 15.292 15.0004'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 13C12.7614 13 15 10.7614 15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M19 16V22' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M22 19H16' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    </SvgIcon>
  );
};
